import React, {useEffect} from 'react';
import './about.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import AboutStats from "../stats/AboutStats";

const About = ({observer, sectionRef}) => {

    useEffect(() => {
        Aos.init({duration:1500})
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current)
        }
    }, [sectionRef, observer])

    return (
        <section id='about'>
            <div data-aos='fade-up' data-aos-duration='2000' className='about_header'>
                <h2 className="eyebrow">Get To Know</h2>
                <h1>About me</h1>
                <div className="about_header_stats" data-aos="zoom-in" data-aos-duration="1200">
                    <AboutStats />
                </div>
            </div>

            <div className='container about_container'>
                <div data-aos='fade-right' data-aos-duration='2000' className='about_me'>
                </div>
                <div data-aos='zoom-in' data-aos-duration='2000' className='about_content'>
                    {/*<div className='about_cards'>*/}
                    {/*    <article className="about_card">*/}
                    {/*        <GiStairsGoal className='about_icon'/>*/}
                    {/*        <h5>Experience</h5>*/}
                    {/*        <p className='small'>1+ Years Working And Study</p>*/}
                    {/*    </article>*/}
                    {/*    <article className="about_card">*/}
                    {/*        <FiUsers className='about_icon'/>*/}
                    {/*        <h5>Clients</h5>*/}
                    {/*        <p className='small'>2+ Worldwide</p>*/}
                    {/*    </article>*/}
                    {/*    <article className="about_card">*/}
                    {/*        <AiOutlineFundProjectionScreen className='about_icon'/>*/}
                    {/*        <h5>Projects</h5>*/}
                    {/*        <p className='small'>5+ Completed</p>*/}
                    {/*    </article>*/}
                    {/*</div>*/}
                    <p className='about_me_text'>
                        I'm Yana, an interior designer and architectural artist with an international background. I create expressive, accurate visuals that help ideas feel tangible before they are built.<br/><br/>
                        I collaborate with:
                        <span className='about_me_list'>Interior designers</span>
                        <span className='about_me_list'>Architects</span>
                        <span className='about_me_list'>Landscape designers</span>
                        <span className='about_me_list'>Real estate agencies</span>
                        Each image balances proportion, material, light and atmosphere—giving you a fast, memorable and cost-effective way to present a concept.<br/><br/>
                        <b id='about_me' ref={sectionRef}>Professional education:</b><br/>
                        Interior Design degree — St. Petersburg International Design School.<br/><br/>
                        <b>Technical skills:</b><br/>
                        I have experience with a variety of tools, including AutoCAD, ArchiCAD, Adobe Photoshop, Procreate, SketchUp.<br/><br/>
                        I’m excited about the possibility of collaborating on your next project and transforming your vision into captivating sketches. Let's turn your ideas into stunning visuals!<br/>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default About;
